//
// This file is auto generated. See ./README.md for details
//
import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
  IconColors,
} from '@hub/design-system-base'
import { default as HamburgerMediumSVG } from './assets/medium/hamburger.inline.svg'

interface HamburgerMediumIconProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
  ariaLabel?: string
  color?: IconColors
}

export const HamburgerMediumIcon: React.FC<
  React.PropsWithChildren<HamburgerMediumIconProps>
> = forwardRef<HamburgerMediumIconProps, typeof ChakraIcon>(
  ({ boxSize = 'size-icon-sm', sx, ariaLabel, color }, ref) => (
    <ChakraIcon
      ref={ref}
      boxSize={boxSize}
      aria-label={ariaLabel}
      as={HamburgerMediumSVG}
      sx={sx}
      color={color}
    />
  )
)
